import { SustainabilityMatterId } from '../../input/materiality-assessment/types-matters';

export type ByMatterId<T> = {
  [id in SustainabilityMatterId]?: T;
};

export type ResultsOfMatter = {
  matterId: SustainabilityMatterId;
  imIsMaterial: boolean;
  fmIsMaterial: boolean;
};

// The *topic-level* ESRS sustainability matters
const csrdEsrsTopicIds = [
  SustainabilityMatterId.E1_CLIMATE_CHANGE,
  SustainabilityMatterId.E2_POLLUTION,
  SustainabilityMatterId.E3_WATER_AND_MARINE_RESOURCES,
  SustainabilityMatterId.E4_BIODIVERSITY,
  SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
  SustainabilityMatterId.S1_OWN_WORKFORCE,
  SustainabilityMatterId.S2_WORKERS_IN_THE_VALUE_CHAIN,
  SustainabilityMatterId.S3_AFFECTED_COMMUNITIES,
  SustainabilityMatterId.S4_CONSUMERS_AND_END_USERS,
  SustainabilityMatterId.G1_BUSINESS_CONDUCT,
] as const;

export type CsrdEsrsTopicId = (typeof csrdEsrsTopicIds)[number];
export function isCsrdEsrsTopicId(id: unknown): id is CsrdEsrsTopicId {
  return csrdEsrsTopicIds.includes(id as CsrdEsrsTopicId);
}

export const esTopicsId = 'entity-specific-topics';
export type EsTopicsId = typeof esTopicsId;

export const csrdTopicIdsWithEsId = [...csrdEsrsTopicIds, esTopicsId] as const;
export type CsrdTopicIdWithEsId = (typeof csrdTopicIdsWithEsId)[number];

export const csrdTopCategoryIds = [
  SustainabilityMatterId.ENVIRONMENT,
  SustainabilityMatterId.SOCIAL,
  SustainabilityMatterId.GOVERNANCE,
] as const;
export type CsrdTopCategoryId = (typeof csrdTopCategoryIds)[number];

export function isCsrdTopCategoryId(id: unknown): id is CsrdTopCategoryId {
  return csrdTopCategoryIds.includes(id as CsrdTopCategoryId);
}

export const csrdTopCategoryIdsWithEsId = [...csrdTopCategoryIds, esTopicsId] as const;
export type CsrdTopCategoryIdWithEsId = (typeof csrdTopCategoryIdsWithEsId)[number];
